<template>
  <div>
    <vx-card title="Perbarui Data" subtitle="Isi data dengan benar">
      <template slot="actions">
          <div class="vx-row">
            <div class="vx-col w-full m-0">
              <vs-button icon-pack="feather" class="mt-2" @click="saveData">Simpan Data</vs-button>
              <vs-button @click="findCompany" class="ml-4 mt-2" type="border" color="danger">Reset</vs-button>
            </div>
          </div>
      </template>
      <div slot="no-body" class="p-6">
        <div class="divider mb-4"></div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full" label="Nama Perusahaan" v-model="form.name" v-validate="'required|alpha_spaces'" name="name" />
                <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
              </div>
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full" label="NPWP" v-model="form.npwp" v-validate="'required|numeric'" name="npwp" />
                <span class="text-danger text-sm" v-show="errors.has('npwp')">{{ errors.first('npwp') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full mt-4" label="Email" v-model="form.email" v-validate="'required|email|min:3'" name="email" />
                <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
              </div>
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full mt-4" label="No. Handphone" v-model="form.phone" v-validate="'numeric'" name="phone" />
                <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <vs-input ref="password" class="w-full mt-4" label="Beginning Balance" v-model="form.init_balance" v-validate="'required|numeric'" name="init_balance" />
                <span class="text-danger text-sm" v-show="errors.has('init_balance')">{{ errors.first('init_balance') }}</span>
              </div>
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full mt-4" label="End Balance" v-model="form.final_balance" v-validate="'required|numeric'" name="final_balance" disabled />
                <span class="text-danger text-sm"  v-show="errors.has('final_balance')">{{ errors.first('final_balance') }}</span>
              </div>
            </div>
            <div class="w-full mt-4">
              <vs-input class="w-full mt-4" label="Website" v-model="form.website" name="website" />
              <span class="text-danger text-sm"  v-show="errors.has('website')">{{ errors.first('website') }}</span>
            </div>
            <div class="w-full mt-4">
              <label class="text-sm opacity-75">Alamat</label>
              <vs-textarea class="w-full" v-model="form.address" name="address" />
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="flex items-start flex-col sm:flex-row">
              <img :src="url" class="rounded mr-4 mt-4" width="300" height="300" />
              <div class="mt-4">
                <input type="file" @change="addLogo" class="hidden" ref="update_logo_input" accept="image/*">
                <vs-button  @click="$refs.update_logo_input.click()" class="mr-4 mb-2" type="filled" icon-pack="feather" icon="icon-edit"></vs-button>
                <vs-button @click="removeLogo()" type="border" color="danger" icon-pack="feather" icon="icon-trash"></vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Store Module
import moduleCompany from '@/store/companies/moduleCompany.js'

export default {
  data () {
    return {
      form:{
        address: null,
        email: null,
        phone: null,
        website: null,
        logo: null,
        init_balance: 0,
        final_balance: 0
      },

      url: null
    }
  },
  created () {
    if (!moduleCompany.isRegistered) {
      this.$store.registerModule('companies', moduleCompany)
      moduleCompany.isRegistered = true
    }

    this.findCompany()
  },
  computed: {
    validateForm () {
      return !this.errors.any() &&
        this.name !== '' &&
        this.npwp !== '' &&
        this.init_balance !== ''  &&
        this.final_balance !== ''
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    addLogo (e) {
      const file = e.target.files[0]
      this.url = URL.createObjectURL(file)
      this.form.logo = file
    },

    removeLogo () {
      this.url = null
      this.form.logo = null
    },

    findCompany () {
      const userData  = this.$store.state.AppActiveUser

      this.$store.dispatch('companies/findCompany', userData.company.id)
        .then(res => {

          const data = res.data.data.company
          // assign the form
          this.form.name = data.name
          this.form.npwp = data.npwp
          this.form.email = data.email
          this.form.phone = data.phone
          this.form.address = data.address
          this.form.website = data.website
          this.form.init_balance = data.init_balance
          this.form.final_balance = data.last_balance
          this.url = `${this.$storagePath + data.logo}`
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
    },

    saveData () {
      const self      = this
      const userData  = this.$store.state.AppActiveUser

      this.$validator.validateAll().then(result => {
        if (result) {

          const formData = new FormData()
          formData.set('name', self.form.name)
          formData.set('npwp', self.form.npwp)
          formData.set('address', self.form.address)
          formData.set('email', self.form.email)
          formData.set('phone', self.form.phone)
          formData.set('website', self.form.website)
          formData.set('init_balance', self.form.init_balance)
          // formData.set('final_balance', self.form.final_balance)
          formData.append('logo', self.form.logo)
          formData.append('_method', 'PUT')

          this.$store.dispatch('companies/updateCompany', {
            id: userData.company.id,
            data: formData
          })
            .then(function () {
              self.$vs.notify({
                color: 'success',
                title: 'Berhasil',
                text: 'Perusahaan berhasil di perbarui'
              })
              self.findCompany()
            })
            .catch(err => {
              self.$vs.notify({
                color: 'danger',
                title: 'Oops..',
                text: err.response.data.message
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.divider {
  background: #E0E0E0;
  height: 1px;
}
</style>
